// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_button__w\\+JtY {
  max-width: 355px;
  min-height: 40px;
  border: none;
  background: #1414ff;
  border-radius: 8px;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  cursor: pointer;
}
.Button_button__w\\+JtY:disabled {
  cursor: initial;
}
.Button_button__w\\+JtY.Button_primary__ki19P {
  border: none;
  background: #1414ff;
}
.Button_button__w\\+JtY.Button_primary__ki19P:hover {
  background: #0000c9;
}
.Button_button__w\\+JtY.Button_primary__ki19P:active {
  background: #000054;
  color: #f5f5ff;
}
.Button_button__w\\+JtY.Button_primary__ki19P:disabled {
  background: #d8d8ff;
  color: #f5f5ff;
}
.Button_button__w\\+JtY.Button_loading__vmp3z {
  background: #1414ff;
  cursor: initial;
}
.Button_button__w\\+JtY.Button_loading__vmp3z svg {
  height: 24px;
  animation-name: Button_rotate__nGK6X;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  vertical-align: sub;
  margin-top: 4px;
}
.Button_button__w\\+JtY.Button_secondary__TOSct {
  border: 1px solid #1414ff;
  background: #fff;
  color: #1414ff;
}
.Button_button__w\\+JtY.Button_secondary__TOSct:hover {
  background: #f5f5ff;
  color: #0000c9;
}
.Button_button__w\\+JtY.Button_secondary__TOSct:active {
  background: #4343ff;
  color: #f5f5ff;
}
.Button_button__w\\+JtY.Button_secondary__TOSct:disabled {
  border: 1px solid #d8d8ff;
  color: #d8d8ff;
}
.Button_button__w\\+JtY.Button_colabel__tJDZ7:disabled {
  background: #C3C3C9 !important;
}

.Button_dashed__a57RT {
  border: 1px dashed #1414ff;
  background: #f5f5ff;
  color: #1414ff;
}

@keyframes Button_rotate__nGK6X {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@media screen and (max-width: 600px) {
  .Button_button__w\\+JtY {
    width: 100% !important;
    max-width: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Button/Button.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBCHS;EDIT,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAIF;AAFE;EACE,eAAA;AAIJ;AADE;EACE,YAAA;EACA,mBCjBO;ADoBX;AADI;EACE,mBCnBK;ADsBX;AAAI;EACE,mBCpBK;EDqBL,cC7BK;AD+BX;AACI;EACE,mBChCK;EDiCL,cClCK;ADmCX;AAGE;EACE,mBCnCO;EDoCP,eAAA;AADJ;AAGI;EACE,YAAA;EACA,oCAAA;EACA,sBAAA;EACA,mCAAA;EACA,iCAAA;EACA,mBAAA;EACA,eAAA;AADN;AAKE;EACE,yBAAA;EACA,gBAAA;EACA,cCpDO;ADiDX;AAKI;EACE,mBC3DK;ED4DL,cCvDK;ADoDX;AAMI;EACE,mBC7DK;ED8DL,cCjEK;AD6DX;AAOI;EACE,yBAAA;EACA,cCrEK;ADgEX;AASE;EACE,8BAAA;AAPJ;;AAWA;EACE,0BAAA;EACA,mBCjFS;EDkFT,cC9ES;ADsEX;;AAYA;EACE;IAAM,uBAAA;EARN;EASA;IAAI,yBAAA;EANJ;AACF;AAQA;EACE;IACE,sBAAA;IACA,kBAAA;EANF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.button {\n  max-width: 355px;\n  min-height: 40px;\n  border: none;\n  background: colors.$primary5;\n  border-radius: 8px;\n  color: #fff;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 28px;\n  cursor: pointer;\n\n  &:disabled {\n    cursor: initial;\n  }\n\n  &.primary {\n    border: none;\n    background: colors.$primary5;\n\n    &:hover {\n      background: colors.$primary6;\n    }\n\n    &:active {\n      background: colors.$primary9;\n      color: colors.$primary1;\n    }\n\n    &:disabled {\n      background: colors.$primary2;\n      color: colors.$primary1;\n    }\n  }\n\n  &.loading{\n    background: colors.$primary5;\n    cursor: initial;\n\n    svg{\n      height: 24px;\n      animation-name: rotate;\n      animation-duration:2s;\n      animation-iteration-count:infinite;\n      animation-timing-function:linear;\n      vertical-align: sub;\n      margin-top: 4px;\n    }\n  }\n\n  &.secondary {\n    border: 1px solid colors.$primary5;\n    background: #fff;\n    color: colors.$primary5;\n\n    &:hover {\n      background: colors.$primary1;\n      color: colors.$primary6;\n    }\n\n    &:active {\n      background: colors.$primary4;\n      color: colors.$primary1;\n    }\n\n    &:disabled {\n      border: 1px solid colors.$primary2;\n      color: colors.$primary2;\n    }\n  }\n\n  &.colabel:disabled{\n    background: colors.$colabelNeutralMid!important;\n  }\n}\n\n.dashed {\n  border: 1px dashed #1414ff;\n  background: colors.$primary1;\n  color: colors.$primary5;\n}\n\n\n@keyframes rotate {\n  from{ transform:rotate(0deg); }\n  to{ transform:rotate(360deg); }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .button {\n    width: 100%!important;\n    max-width: initial;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"button": `Button_button__w+JtY`,
	"primary": `Button_primary__ki19P`,
	"loading": `Button_loading__vmp3z`,
	"rotate": `Button_rotate__nGK6X`,
	"secondary": `Button_secondary__TOSct`,
	"colabel": `Button_colabel__tJDZ7`,
	"dashed": `Button_dashed__a57RT`
};
export default ___CSS_LOADER_EXPORT___;
